export enum CrudEnum {
  C = 'C',
  R = 'R',
  U = 'U',
  D = 'D'
}
